

import React, { useEffect, useState } from "react";
import "../assets/employereportnew.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeeReport, deleteEmployee } from "../redux/slices/employeeReportSlice";
import { toast } from "react-toastify";
import EmployeeEditModal from "../modals/EmployeeEditModal";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";



const EmployeeReport = () => {
  const dispatch = useDispatch();
  const { list: data, loading, error, currentPage, totalPages } = useSelector(
    (state) => state.employeeReport
  );

  const [filterType, setFilterType] = useState("userId");
  const [filterValue, setFilterValue] = useState("");
  const [branch, setBranch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const pageSize = 10;

  const fetchData = (page = 1) => {
    dispatch(
      fetchEmployeeReport({
        page,
        pageSize,
        filterType,
        filterValue,
        branch,
        fromDate,
        toDate,
      })
    );
  };

  useEffect(() => {
    fetchData(1);
  }, []);

const handlepreviewclick = async (id) =>{
     try {
        const res = await fetch(
          `https://narrowitsolution.in/api/list-employee-kyc?userId=${id}`
        );
        const data = await res.json();
        if (res.ok && data.documents?.length > 0) {
          const photoDoc = data.documents.find(
            (doc) => doc.docName?.toLowerCase() === "photo"
          );

          
      console.log("photoDoc.docImage");
      console.log(photoDoc.docImage);
          if (photoDoc?.docImage) {
            // setPhotoUrl(`https://narrowitsolution.in/uploads/${photoDoc.docImage}`);
            setPreviewImage(`https://narrowitsolution.in/uploads/${photoDoc.docImage}`)
          }
        }
      } catch (err) {
        console.error("Failed to fetch employee photo:", err);
      }
      
    };


  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this employee?")) return;
    try {
      await dispatch(deleteEmployee(id)).unwrap();
      toast.success("Employee deleted successfully!");
      fetchData(currentPage); // refresh current page
    } catch (err) {
      toast.error(err);
    }
  };

  console.log("data is ",data);


  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      fetchData(pageNumber);
    }
  };






const downloadExcel = () => {
  if (!data || data.length === 0) {
    toast.warn("No data to export");
    return;
  }

  const excelData = data.map((row, index) => ({
    "SN": (currentPage - 1) * pageSize + index + 1,
    "Employee ID": row.userId,
    "Name": row.fullName,
    "Email": row.email,
    "Mobile": row.mobileNumber,
    "Branch": row.branchName,
    "Role": row.roleName,
    "Aadhaar": row.aadhaarNumber,
    "PAN": row.panNumber,
    "Address": row.address || "",
    "DOB": row.dateOfBirth?.split("T")[0],
    "Joining Date": row.dateOfJoining?.split("T")[0],
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Employees");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const file = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(file, `Employee_Report_${Date.now()}.xlsx`);
};



const downloadPDF = () => {
  if (!data || data.length === 0) {
    toast.warn("No data to export");
    return;
  }

  const doc = new jsPDF("l", "mm", "a4");

  doc.text("Employee Report", 14, 15);

  const tableColumn = [
    "SN",
    "Emp ID",
    "Name",
    "Email",
    "Mobile",
    "Branch",
    "Role",
    "Aadhaar",
    "PAN",
    "DOB",
    "Joining Date",
  ];

  const tableRows = data.map((row, index) => [
    (currentPage - 1) * pageSize + index + 1,
    row.userId,
    row.fullName,
    row.email,
    row.mobileNumber,
    row.branchName,
    row.roleName,
    row.aadhaarNumber,
    row.panNumber,
    row.dateOfBirth?.split("T")[0],
    row.dateOfJoining?.split("T")[0],
  ]);

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 20,
    styles: { fontSize: 8 },
  });

  doc.save(`Employee_Report_${Date.now()}.pdf`);
};





  return (
    <div className="CustomerReport-container">
      <h2 className="CustomerReport-heading">Employee Report</h2>

      {/* Filters */}
      <div className="CustomerReport-filterSection">
        <div className="CustomerReport-filterGroup">
          <label>From Date</label>
          <input
            type="date"
            className="CustomerReport-input"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>
        <div className="CustomerReport-filterGroup">
          <label>To Date</label>
          <input
            type="date"
            className="CustomerReport-input"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>
        {/* <div className="CustomerReport-filterGroup">
          <label>Branch</label>
          <input
            type="text"
            className="CustomerReport-input"
            placeholder="Enter Branch"
            value={branch}
            onChange={(e) => setBranch(e.target.value)}
          />
        </div> */}
        <div className="CustomerReport-filterGroup">
          <label>Filter By</label>
          <select
            className="CustomerReport-input"
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
          >
            <option value="userId">User ID</option>
            {/* <option value="aadhar">Aadhar</option>
            <option value="pan">PAN</option>
            <option value="phone">Mobile</option>
            <option value="dob">DOB</option>
            <option value="name">Name</option> */}
          </select>
        </div>
        <div className="CustomerReport-filterGroup">
          <label>{filterType.toUpperCase()}</label>
          <input
            type={filterType === "dob" ? "date" : "text"}
            className="CustomerReport-input"
            placeholder={`Enter ${filterType.toUpperCase()}`}
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
          />
        </div>
        <div className="CustomerReport-filterGroup buttonWrapper">
          <button className="CustomerReport-submit" onClick={() => fetchData(1)}>
            Submit
          </button>
        </div>
      </div>

      <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
  <button
    className="CustomerReport-submit"
    onClick={downloadExcel}
  >
    ⬇️  Excel
  </button>

  <button
    className="CustomerReport-submit"
    onClick={downloadPDF}
  >
    ⬇️  PDF
  </button>
</div>


      {/* Table */}
      <div className="CustomerReport-tableWrapper">
        {loading ? (
          <p style={{ textAlign: "center" }}>Loading...</p>
        ) : error ? (
          <p style={{ color: "red", textAlign: "center" }}>{error}</p>
        ) : (
          <>
            <table className="CustomerReport-table">
              <thead>
                <tr>
                  <th>SN</th>
                  <th>Id</th>
                  <th>Emp. ID</th>
                  <th>User Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Branch</th>
                  <th>Role</th>
                  <th>Aadhar</th>
                  <th>PAN</th>
                  <th>Address</th>
                  <th>DOB</th>
                  <th>Joining Date</th>
                  <th>Update</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((row, index) => (
                    <tr key={row.id}>
                      <td>{(currentPage - 1) * pageSize + index + 1}</td>
                      {/* <td>
                        <img
                          src={`https://ui-avatars.com/api/?name=${row.id}&background=random`}
                          alt="Profile"
                        />
                      </td> */}
                      <td>
                        <button
                          className="preview-btn-emprpt"
                          onClick={() =>
                            handlepreviewclick(row.userId)
                          }
                        >
                          Preview
                        </button>
                      </td>
                     
                      <td>{row.userId}</td>
                      <td>{row.fullName}</td>
                      <td>{row.email}</td>
                      <td>{row.mobileNumber}</td>
                      <td>{row.branchName}</td>
                      <td>{row.roleName}</td>
                      <td>{row.aadhaarNumber}</td>
                      <td>{row.panNumber}</td>
                      <td>{row.address || "—"}</td>
                      <td>{row.dateOfBirth?.split("T")[0]}</td>
                      <td>{row.dateOfJoining?.split("T")[0]}</td>
                      <td>
                        <button
                          className="CustomerReport-action"
                          onClick={() => {
                            setIsModalOpen(true);
                            setSelectedEmployee(row);
                          }}
                          title="Update"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                      </td>

                      <td>
                        <button
                          className="CustomerReport-action delete-btn"
                          onClick={() => handleDelete(row.id)}
                          title="Delete"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="15" style={{ textAlign: "center" }}>
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

         
          </>
        )}
      </div>

      {/* Pagination */}
         {totalPages > 1 && (
              <div className="CustomerReport-paginationCard">
                <div className="CustomerReport-pagination">
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Prev
                  </button>

                  <span className="CustomerReport-pageIndicator">
                    Page {currentPage} of {totalPages}
                  </span>

                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}


            {/* 🔹 Preview Modal */}
            {previewImage && (
              <div className="modal-overlay" onClick={() => setPreviewImage(null)}>
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                  <img src={previewImage} alt="KYC Preview" className="modal-image" />
                  <button
                    className="modal-close"
                    onClick={() => setPreviewImage(null)}
                  >
                    ×
                  </button>
                </div>
              </div>
            )}

            {/* Edit Modal */}
            <EmployeeEditModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              employee={selectedEmployee}
              onUpdated={() => fetchData(currentPage)}
            />
    </div>
  );
};

export default EmployeeReport;
